"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _canvasUiReact = require("@enterprise-ui/canvas-ui-react");
var _icons = _interopRequireWildcard(require("@enterprise-ui/icons"));
var _constants = require("../../constants/constants");
require("../../styles/index.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getInitials = userInfo => {
  var _userInfo$firstName, _userInfo$lastName;
  return "".concat(userInfo === null || userInfo === void 0 || (_userInfo$firstName = userInfo.firstName) === null || _userInfo$firstName === void 0 ? void 0 : _userInfo$firstName.charAt(0)).concat(userInfo === null || userInfo === void 0 || (_userInfo$lastName = userInfo.lastName) === null || _userInfo$lastName === void 0 ? void 0 : _userInfo$lastName.charAt(0));
};
const Header = _ref => {
  var _session$identity, _additionalSelectorDe, _additionalSelectorDe2, _additionalSelectorDe3, _session$userInfo, _session$userInfo2, _session$userInfo3, _session$userInfo4, _session$userInfo5;
  let {
    userRole,
    useAuth,
    additionalSelectorDetails,
    appTitle,
    isSupportVisible,
    supportUrl
  } = _ref;
  const auth = useAuth();
  const {
    logout,
    session
  } = auth;
  const helpSupport = (session === null || session === void 0 || (_session$identity = session.identity) === null || _session$identity === void 0 ? void 0 : _session$identity.business_category) === 'E' ? _constants.HELP_SUPPORT_URL.EXTERNAL : _constants.HELP_SUPPORT_URL.INTERNAL;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_canvasUiReact.Layout.MenuButton, null, /*#__PURE__*/React.createElement("div", {
    className: "flex-align-center"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/",
    "aria-label": "Home"
  }, /*#__PURE__*/React.createElement(_icons.default, {
    icon: _icons.BrandIcon,
    size: "xl",
    className: "enterprise-icon",
    style: {
      height: 36
    }
  })), /*#__PURE__*/React.createElement("h1", {
    className: "hc-fs-md hc-lh-expanded hc-ml-dense font-weight-700"
  }, appTitle ? appTitle : 'ItemHub'))), /*#__PURE__*/React.createElement(_canvasUiReact.Layout.Header, {
    // includeRail
    "data-testid": "header",
    className: "hc-ph-expanded"
  }), /*#__PURE__*/React.createElement(_canvasUiReact.Layout.GlobalActions, null, /*#__PURE__*/React.createElement(_canvasUiReact.Grid.Container, {
    justify: "flex-end"
  }, additionalSelectorDetails && additionalSelectorDetails !== null && additionalSelectorDetails !== void 0 && (_additionalSelectorDe = additionalSelectorDetails.options) !== null && _additionalSelectorDe !== void 0 && _additionalSelectorDe.length && additionalSelectorDetails !== null && additionalSelectorDetails !== void 0 && additionalSelectorDetails.value ? /*#__PURE__*/React.createElement(_canvasUiReact.Grid.Item, {
    className: "flex-align-center"
  }, additionalSelectorDetails.options.length === 1 ? /*#__PURE__*/React.createElement("span", {
    className: "hc-mr-normal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hc-fs-sm additional-selector-details-text uii-user-details"
  }, /*#__PURE__*/React.createElement("strong", null, additionalSelectorDetails === null || additionalSelectorDetails === void 0 ? void 0 : additionalSelectorDetails.label)), /*#__PURE__*/React.createElement("div", {
    className: "hc-fs-xs additional-selector-details-text uii-user-details",
    "data-testid": "additional-selector-details-display"
  }, /*#__PURE__*/React.createElement("span", {
    className: "additional-selector-details-text"
  }, (_additionalSelectorDe2 = additionalSelectorDetails.options.find(option => option.value === (additionalSelectorDetails === null || additionalSelectorDetails === void 0 ? void 0 : additionalSelectorDetails.value))) === null || _additionalSelectorDe2 === void 0 ? void 0 : _additionalSelectorDe2.label))) : /*#__PURE__*/React.createElement(_canvasUiReact.Dropdown, {
    className: "hc-mr-normal",
    size: "dense",
    location: "bottom-left"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-align-center"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "hc-fs-sm additional-selector-details-text uii-user-details"
  }, /*#__PURE__*/React.createElement("strong", null, additionalSelectorDetails === null || additionalSelectorDetails === void 0 ? void 0 : additionalSelectorDetails.label)), /*#__PURE__*/React.createElement("div", {
    className: "hc-fs-xs additional-selector-details-text",
    "data-testid": "additional-selector-details-display"
  }, (_additionalSelectorDe3 = additionalSelectorDetails.options.find(option => option.value === (additionalSelectorDetails === null || additionalSelectorDetails === void 0 ? void 0 : additionalSelectorDetails.value))) === null || _additionalSelectorDe3 === void 0 ? void 0 : _additionalSelectorDe3.label)), /*#__PURE__*/React.createElement(_canvasUiReact.Button, {
    iconOnly: true,
    type: "ghost",
    "aria-label": "".concat(additionalSelectorDetails.label, " user action menu"),
    "data-testid": "additional-selector-details-action-button",
    className: "user-profile-action"
  }, /*#__PURE__*/React.createElement(_icons.default, {
    icon: _icons.CaretDownIcon,
    size: "xl"
  }))), /*#__PURE__*/React.createElement(_canvasUiReact.Dropdown.Menu, {
    style: {
      width: 'fit-content',
      maxHeight: '80vh',
      overflow: 'scroll'
    }
  }, additionalSelectorDetails.options.map(option => {
    return /*#__PURE__*/React.createElement(_canvasUiReact.Dropdown.MenuItem, {
      key: (option === null || option === void 0 ? void 0 : option.id) + '_menu_item',
      "data-testid": (option === null || option === void 0 ? void 0 : option.id) + '_menu_item',
      onClick: () => additionalSelectorDetails === null || additionalSelectorDetails === void 0 ? void 0 : additionalSelectorDetails.onSelect(option === null || option === void 0 ? void 0 : option.value)
    }, option === null || option === void 0 ? void 0 : option.label);
  })))) : null, /*#__PURE__*/React.createElement(_canvasUiReact.Grid.Item, {
    className: "flex-align-center"
  }, isSupportVisible && /*#__PURE__*/React.createElement(_canvasUiReact.Anchor, {
    href: supportUrl ? supportUrl : helpSupport,
    target: "_blank",
    className: "uii-user-details hc-mr-lg hc-mb-dense"
  }, /*#__PURE__*/React.createElement(_icons.default, {
    icon: _icons.HelpIcon,
    size: "md"
  })), /*#__PURE__*/React.createElement(_canvasUiReact.Avatar, {
    color: "lime",
    size: "normal",
    className: "hc-fs-md",
    "aria-label": "Avatar showing the initials for ".concat(session === null || session === void 0 || (_session$userInfo = session.userInfo) === null || _session$userInfo === void 0 ? void 0 : _session$userInfo.fullName)
  }, getInitials(session === null || session === void 0 ? void 0 : session.userInfo)), /*#__PURE__*/React.createElement("div", {
    className: "hc-ml-dense hc-fs-md hc-pr-normal uii-user-details"
  }, /*#__PURE__*/React.createElement("span", null, session === null || session === void 0 || (_session$userInfo2 = session.userInfo) === null || _session$userInfo2 === void 0 ? void 0 : _session$userInfo2.firstName, " ", session === null || session === void 0 || (_session$userInfo3 = session.userInfo) === null || _session$userInfo3 === void 0 ? void 0 : _session$userInfo3.lastName), userRole && /*#__PURE__*/React.createElement("pre", {
    className: "hc-fs-xs"
  }, userRole)), /*#__PURE__*/React.createElement(_canvasUiReact.Dropdown, {
    size: "dense",
    location: "bottom-right"
  }, /*#__PURE__*/React.createElement(_canvasUiReact.Button, {
    iconOnly: true,
    type: "ghost",
    "aria-label": "user action menu",
    "data-testid": "headerGlobalActionsButton",
    className: "user-profile-action"
  }, /*#__PURE__*/React.createElement(_icons.default, {
    icon: _icons.CaretDownIcon,
    size: "xl"
  })), /*#__PURE__*/React.createElement(_canvasUiReact.Dropdown.Menu, null, (session === null || session === void 0 || (_session$userInfo4 = session.userInfo) === null || _session$userInfo4 === void 0 ? void 0 : _session$userInfo4.company) && /*#__PURE__*/React.createElement(_canvasUiReact.Dropdown.MenuItem, {
    "data-testid": "headerSettingsButton",
    disabled: true
  }, /*#__PURE__*/React.createElement(_icons.default, {
    icon: _icons.WorkspaceIcon,
    size: "sm"
  }), /*#__PURE__*/React.createElement("span", {
    className: "hc-fs-sm hc-ml-dense"
  }, session === null || session === void 0 || (_session$userInfo5 = session.userInfo) === null || _session$userInfo5 === void 0 ? void 0 : _session$userInfo5.company)), /*#__PURE__*/React.createElement(_canvasUiReact.Dropdown.MenuItem, {
    "data-testid": "headerLogoutButton",
    onClick: logout
  }, /*#__PURE__*/React.createElement(_icons.default, {
    icon: _icons.LogoutIcon,
    size: "sm"
  }), /*#__PURE__*/React.createElement("span", {
    className: "hc-fs-sm hc-ml-dense"
  }, " Log Out"))))))));
};
var _default = exports.default = Header;